import ArrowLeftDisabled from './assets/arrow-left-disabled.svg';
import ArrowLeftMatch from './assets/arrow-left-match.svg';
import ArrowLeftMismatch from './assets/arrow-left-mismatch.svg';
import ArrowRightDisabled from './assets/arrow-right-disabled.svg';
import ArrowRightMatch from './assets/arrow-right-match.svg';
import ArrowRightMismatch from './assets/arrow-right-mismatch.svg';

export type ArrowState = 'disabled' | 'match' | 'mismatch';

export const Arrows: {
	incoming: Record<ArrowState, string>;
	outgoing: Record<ArrowState, string>;
} = {
	incoming: {
		disabled: ArrowLeftDisabled,
		match: ArrowLeftMatch,
		mismatch: ArrowLeftMismatch,
	},
	outgoing: {
		disabled: ArrowRightDisabled,
		match: ArrowRightMatch,
		mismatch: ArrowRightMismatch,
	},
};
